<script>
    import { sgettext } from '../../i18n.js';
    import Modal from '../Modal.svelte';
    import DataTable from '../DataGrid/DataTable.svelte';
    import D2PublicationFailureReasonColumn from './D2PublicationFailureReasonColumn.svelte';
    import D2PublicationFailureReasonDescriptionColumn from './D2PublicationFailureReasonDescriptionColumn.svelte';

    export let id = 'd2FailureReasons';

    let statusData = [
        {
            publication_status_display_name: sgettext('$$PUBLISHED_1$$'),// key defined in snake case to keep it the same as the serialised value
            publication_status: "Success",
            descriptionTitle: sgettext('$$PUBLISHED$$'),
            description: sgettext('$$DOCUMENT_SUCCESSFULLY_PUBLISHED_SYSTEM$$')
        },
        {
            publication_status_display_name: sgettext('$$PENDING_PUBLICATION$$'),
            publication_status: "Pending",
            descriptionTitle: sgettext('$$PENDING_PUBLICATION_1$$'),
            description: sgettext('$$DOCUMENT_CURRENTLY_UNDERGOING_WORK$$')
        },
        {
            publication_status_display_name: sgettext('$$PDF_GENERATION_FAIL$$'),
            publication_status: "Retryable Fail",
            descriptionTitle: sgettext('$$PDF_GENERATION_ERROR$$'),
            description: sgettext('$$FAILURE_GENERATING_PDF_INSTRUCTIONS$$')
        },
        {
            publication_status_display_name: sgettext('$$INVALID_STATE$$'),
            publication_status: "Retryable Fail",
            descriptionTitle: sgettext('$$SYNCHRONISATION_ERROR$$'),
            description: sgettext('$$INABILITY_SYNCHRONISE_WORK_INSTRUCTIONS$$')
        },
        {
            publication_status_display_name: sgettext('$$CHECKOUT_PROHIBITED$$'),
            publication_status: "Retryable Fail",
            descriptionTitle: sgettext('$$DOCUMENT_LOCK_ERROR$$'),
            description: sgettext('$$DOCUMENT_LOCKED_EDITING_SYSTEM_PLEASE$$')
        },
        {
            publication_status_display_name: sgettext('$$TRANSITION_FAIL$$'),
            publication_status: "Retryable Fail",
            descriptionTitle: sgettext('$$INVALID_METADATA$$'),
            description: sgettext('$$REQUIRED_METADATA_FIELDS_MISSING_PLEASE$$')
        },
        {
            publication_status_display_name: sgettext('$$CREATE_FAIL$$'),
            publication_status: "Retryable Fail",
            descriptionTitle: sgettext('$$WORK_INSTRUCTION_CREATION_ERROR$$'),
            description: sgettext('$$ERROR_ENCOUNTERED_CREATING_NEW_DOCUMENT$$')
        },
        {
            publication_status_display_name: sgettext('$$D2_PUBLICATION_FAIL$$'),
            publication_status: "Fail",
            descriptionTitle: sgettext('$$WORK_INSTRUCTION_PUBLICATION_ERROR$$'),
            description: sgettext('$$ERROR_OCCURRED_PUBLICATION_WITHIN_SYSTEM$$')
        },
    ];

    let columns = {
        status: {
            label: sgettext('$$STATUS$$'),
            width: '30%',
            renderer: D2PublicationFailureReasonColumn,
        },
        description: {
            label: sgettext('$$DESCRIPTION$$'),
            width: '70%',
            renderer: D2PublicationFailureReasonDescriptionColumn,
        }
    };
</script>

<Modal {id} large={true} title={sgettext('$$D2_PUBLICATION_STATUSES$$')}>
  <div slot="body">
    <DataTable
      {columns}
      rows={statusData}
      emptyLabel={sgettext('$$ERRORS_FOUND$$')}
    />
  </div>
  <div slot="footer" />
</Modal>
